import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 830;

function getIsMobileView() {
    if (typeof window === "undefined") {
        return false;
    }

    return window.innerWidth <= MOBILE_BREAKPOINT;
}

export function useIsMobileView() {
    const [isMobileView, setIsMobileView] = useState(getIsMobileView);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(getIsMobileView());
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return isMobileView;
}

export { MOBILE_BREAKPOINT };
